/**
 * ReviewBadges - the SourceForge and TopBusinessSoftware review badges, shown
 * in the footer's brand column under the trust line.
 *
 * PLACEMENT is deliberate. These sit with "HIPAA compliant / Trust Center",
 * "Built by S7 Lab" and "Backed by Y Combinator" rather than in a nav column,
 * because all of them are the same kind of thing: third-party corroboration
 * that we are real. Grouped, they read as a credibility block. Scattered, they
 * read as decoration.
 *
 * RESTRAINT is what keeps a review badge from looking tacky. They render at
 * 100px rather than the vendor's 125, side by side, at 0.75 opacity lifting to
 * full on hover, so they sit quietly under the trust line instead of shouting.
 *
 * WHY THE ARTWORK IS SELF-HOSTED.
 * The badges are static award artwork ("Customers Love Us", "Most Loved"). Every
 * client-side path to the vendor's own host (b.sf-syn.com) is blocked by the
 * production Content-Security-Policy: its `script-src` blocked the vendor's
 * badge_js snippet (so the badge showed as plain fallback text), and its
 * `img-src` blocks a badge_img <img> (so it showed as a broken image). The CSP
 * is set at the edge, not in this repo, so it does not apply in local dev, which
 * is why a remote <img> verified green locally but failed in production.
 * Serving the SVG from our own origin (/badges/*.svg) is allowed by `img-src
 * 'self'` with no infra change, drops the third-party request entirely, and
 * removes the dependency on vendor uptime. The anchors still link out to the
 * live SourceForge / Top Business Software review pages.
 */

type Badge = {
  src: string;
  href: string;
  label: string;
};

const BADGES: Badge[] = [
  {
    src: "/badges/sourceforge.svg",
    href: "https://sourceforge.net/software/product/Altair-Health/",
    label: "Altair reviews on SourceForge",
  },
  {
    src: "/badges/top-business-software.svg",
    href: "https://topbusinesssoftware.com/products/Altair-Health/reviews/",
    label: "Altair reviews on Top Business Software",
  },
];

export function ReviewBadges() {
  return (
    <div className="mt-5 flex flex-wrap items-center gap-3">
      {BADGES.map((b) => (
        <a
          key={b.href}
          href={`${b.href}?pk_campaign=badge&pk_source=vendor`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={b.label}
          className="block opacity-75 transition-opacity hover:opacity-100"
          style={{ width: 100 }}
        >
          <img
            src={b.src}
            alt={b.label}
            loading="lazy"
            className="block h-auto w-full"
          />
        </a>
      ))}
    </div>
  );
}
